module.exports = __webpack_public_path__ + "static/bubble_small-e5a67d768c6b6390917c31e756a6e2fc.png";